import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {
  currLang;
  @Input("controls") controls;
  @Input("type") type;
  @Output("eventHandler") eventHandler = new EventEmitter();

  dataArray = [];
  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnChanges() {
    this.dataArray = this.controls;
  }

  getRoleName(role) {
    let keys = ['school_admin', 'teacher', 'supervisor', 'security', 'manager' , 'cafeteria' , 'gate'];
    let roleIndex = keys.findIndex(key => key === role);
    let roleToReturn = roleIndex === -1 ? role : this.translate.instant(`roles.${role}`)
    return roleToReturn;
  }

  errorClicked(row) {
    this.eventHandler.emit({
      type: "errorClicked",
      row: row
    });
  }
}
